import { app } from "@/main";
import { createMarkdownVNode, isMarkdownSyntax } from "@/utils/markdownAdapter";

const createToastMessage = (content) => {
  if (typeof content === "string") {
    if (isMarkdownSyntax(content)) {
      return createMarkdownVNode(content);
    }
    return content;
  }

  if (content?.template) {
    if (
      typeof content.template === "string" &&
      isMarkdownSyntax(content.template)
    ) {
      return createMarkdownVNode(content.template, content.context || {});
    }

    const h = app.$createElement;
    return h("div", {}, content.template);
  }

  throw new Error("Toast content is not valid");
};

const showToast = (toast, toastMessage, options) => {
  toast.toast(toastMessage, {
    ...options,
  });
};

export default function initShowToast(Vue) {
  // Note: another type of toast could be defined here (info, warning, etc.)
  Vue.prototype.$showToastError = function showToastError(
    content,
    options = {}
  ) {
    const toastMessage = createToastMessage(content);
    showToast(this.$root.$bvToast, toastMessage, {
      ...options,
      variant: "danger",
      title: options.title || "Error",
    });
  };

  Vue.prototype.$showToastSuccess = function showToastSuccess(
    content,
    options = {}
  ) {
    const toastMessage = createToastMessage(content);
    showToast(this.$root.$bvToast, toastMessage, {
      ...options,
      variant: "success",
      title: options.title || "Success",
    });
  };
}
